export var DEFAULT_TOTAL_MONTH_NUMBER = 2;
export var DEFAULT_SUBTRACT_MONTH_NUMBER = 1;
export var DEFAULT_TABLE_HEIGHT = 300;
export var DEFAULT_MIN_RANGE = 1;
export var DEFAULT_MAX_RANGE = 366;